import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68261f48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-login__item user-login__forget" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-login__sec" }, "验证手机号", -1))
const _hoisted_3 = { class: "user-login__forget-foot" }

import { ref } from 'vue';
import { BaseButton } from 'xrk-components';

import type { FormRef, FormData } from '../types/index';
import { LoginForm } from './login-base/index';
import { LoginTypeEnum, FormItemEnum } from '../constants/index';

import { phoneLogin } from '../data-source/apis';

import { useSetup } from '../store';

const forgetThePassword = 1;
// 表单实例

export default /*#__PURE__*/_defineComponent({
  __name: 'login-forget',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const store = useSetup();
const model = _useModel(__props, "modelValue");
const itemList = ref<any[]>([FormItemEnum.phone]);
const formRef = ref<FormRef>(null);
const formData = ref<FormData>({
  [FormItemEnum.phone]: store.loginData.phone2
});

const onCancel = () => {
  model.value = 'login-main';
};

const onLogin = async () => {
  await formRef.value.validate();
  const { data } = await phoneLogin({
    [FormItemEnum.phone]: formRef.value.data[FormItemEnum.phone],
    [FormItemEnum.code]: formRef.value.data[FormItemEnum.code],
    forgetThePassword
  });
  // 仅同步信息
  store.setInfo(data);
  store.setLoginData({ phone2: formRef.value.data[FormItemEnum.phone] });
  model.value = 'login-reset';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(LoginForm), {
      ref_key: "formRef",
      ref: formRef,
      formData: formData.value,
      itemList: itemList.value,
      pageType: _unref(LoginTypeEnum).FORGET
    }, null, 8, ["formData", "itemList", "pageType"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(BaseButton), {
        onClick: onCancel,
        type: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), { click: onLogin }, {
        default: _withCtx(() => [
          _createTextVNode("下一步")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})